import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import FAppError from '../FAppError';
import useAppErrorProbe from './hooks/useAppErrorProbe';
import appErrorProbeLang from './langs/appErrorProbeLang';

type FAppErrorProbeProps = {
	children: ReactElement;
};
const FAppErrorProbe = (props: FAppErrorProbeProps) => {
	const { data } = useAppErrorProbe();
	const { t } = useTranslation();

	return (
		<>
			{data === false ? (
				<FAppError
					isBackButtonDisplay={false}
					title={t(appErrorProbeLang.title.tag)}
					content={t(appErrorProbeLang.content.tag)}
				/>
			) : (
				<>{props.children}</>
			)}
		</>
	);
};

export default FAppErrorProbe;
